import { render, staticRenderFns } from "./DevModeSkipButtons.vue?vue&type=template&id=5caae5dc&"
import script from "./DevModeSkipButtons.vue?vue&type=script&lang=js&"
export * from "./DevModeSkipButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports